import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {IAppInfo} from "./types";
import {fetchIsServerDown} from "./asyncAction";

const initialState: IAppInfo = {
  serverDown: false,
  message: ''
};

const appInfoSlice = createSlice({
  name: "appInfo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchIsServerDown.fulfilled, (state, action: PayloadAction<string>) => {
      state.serverDown = !action.payload
    });
    builder.addCase(fetchIsServerDown.rejected, (state, action: PayloadAction<any>) => {
      state.serverDown = true
      state.message = action.payload
    });
  }
})

export default appInfoSlice.reducer;
